// extracted by mini-css-extract-plugin
export default {"textValue":"Summary_textValue__TBxHl","bullets":"Summary_bullets__1hMLs","showToggle":"Summary_showToggle__14a-W","showToggleIcon":"Summary_showToggleIcon__xqWhy"};